module.exports = __webpack_public_path__ + "img/budget-types.4022775f.svg";